/* eslint-disable jsx-a11y/img-redundant-alt */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { Button } from "../../components/ui/button";
import Loader from "../../components/loader";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import ProductCard from "../../components/productCard";
import "./styles.css"
import axios from "axios";
import { get_user_data, getAllCategories, getCategorieActeur, popularProducts } from "../../lib/apis";
import { ProductInterface } from "../../lib/Interfaces/Product.interface";
import { CategorieInterface } from "../../lib/Interfaces/Categorie.interface";

import { ArrowRight, ChartBarIncreasing, CloudSun, Eye, MapPin, Package, Star, Truck, UserCog, UserPlus } from "lucide-react";
import Carousel from "../../components/Carousel";
import { ToastContainer } from "react-toastify";
import ServiceCard, { ServiceCardProps } from "../../components/service/ServiceCard";
import { motion } from 'framer-motion';
import DashboardStats from "./DashboardStats";
import { scrollToTop } from "../../lib/utils";


const Home = () => {
  const [newProduct, setNewProduct] = useState<ProductInterface[]>([])
  const [popularProduct, setPopularProduct] = useState<ProductInterface[]>([])
  const [categories, setCategories] = useState<CategorieInterface[]>([])
  const [load, setLoad] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(true)
  const [userCategories, setUserCategories] = useState([])
  const [allDataUserCat, setAllDataUserCat] = useState<any>()
  const [allDataCat, setAllDataCat] = useState<any>()
  const [loader, setLoader] = useState(true)
  const { t, i18n } = useTranslation(); // Translation hook
  const scrollRef = useRef<HTMLDivElement>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null); // Pour stocker l’intervalle
  const [usersData, setUsersData] = useState<any>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadUserdata, setLoadUserData] = useState(true)
  let scrollAmount = 0;

  useEffect(() => {
    scrollToTop()
  }, [])

  const updateUserCategorie = async () => {
    const currentLanguage = i18n.language
    try {
      const { data } = await axios.get(getCategorieActeur)
      setAllDataUserCat(data)
      if (currentLanguage === "fr") {
        setUserCategories(data.data)
      } else {
        setUserCategories(data.dataE)
      }

    } catch (error) {
    } finally {
      setLoader(false)
    }
  }

  const getUserData = async () => {
    try {
      const { data } = await axios.get(get_user_data)
      setUsersData(data.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadUserData(false)
    }
  }

  useEffect(() => {
    const currentLanguage = i18n.language
    if (allDataUserCat) {
      if (currentLanguage === "fr") {
        setUserCategories(allDataUserCat.data)
      } else {
        setUserCategories(allDataUserCat.dataE)
      }
    }
    if (allDataCat) {
      if (currentLanguage === "fr") {
        setCategories(allDataCat.data)
      } else {
        setCategories(allDataCat.dataE)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language])

  useEffect(() => {
    updateUserCategorie()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getUserData()
  }, [])

  console.log(usersData)
  const navigate = useNavigate();


  const startScrolling = () => {
    const container = scrollRef.current;
    if (!container) return;

    intervalRef.current = setInterval(() => {
      scrollAmount += 1;
      container.scrollLeft = scrollAmount;

      if (scrollAmount >= container.scrollWidth - container.clientWidth) {
        clearInterval(intervalRef.current!);
      }
    }, 10);
  };

  const stopScrolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    startScrolling();

    return () => stopScrolling(); // Nettoyage à la fin
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updaCategory = async () => {
    // setLoad(true)
    const currentLanguage = i18n.language
    try {
      const { data } = await axios.get(getAllCategories)
      setAllDataCat(data)
      if (currentLanguage === "fr") {
        setCategories(data.data)
      } else {
        setCategories(data.dataE)
      }
      // setCategories(data.data)
      // console.log("categorie", data)
    } catch (error) {
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    updaCategory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const updateProducts = async () => {
    // setLoading(true)
    try {
      const { data } = await axios.get(popularProducts)
      setNewProduct(data.new_products)
      setPopularProduct(data.popular_products)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    updateProducts()
  }, [])










  const services: ServiceCardProps[] = [
    {
      icon: <Truck className="w-8 h-8 text-white" />,
      title: t("recherche_transporteur"),
      description: t("trouver_transporteur"),
      buttonText: t("commencer"),
      buttonLink: "/recherche_trans/0",
      image: "/assets/deliver.png",
      gradient: "from-yellow-500 to-yellow-600",
      stats: [
        { label: t("transporteurs"), value: "500+" },
        { label: t("livraisons"), value: "10K+" }
      ]
    },
    {
      icon: <ChartBarIncreasing className="w-8 h-8 text-white" />,
      title: t("consulter_prix"),
      description: t("acceder_prix"),
      buttonText: t("explorer"),
      buttonLink: "/consulter",
      image: "/fruits.svg",
      gradient: "from-orange-500 to-red-500",
      stats: [
        { label: t("produits"), value: "1000+" },
        { label: t("prix_maj"), value: t("quotidien") }
      ]
    },
    {
      icon: <UserPlus className="w-8 h-8 text-white" />,
      title: t("devenez_vendeur"),
      description: t("slogan_transporteur"),
      buttonText: t("vender_maintenant"),
      buttonLink: "/devenir_producteur",
      image: "/assets/african-man-harvesting-vegetables.png",
      gradient: "from-green-500 to-emerald-600",
      badge: t("populaire") || "Populaire",
      stats: [
        { label: t("vendeurs"), value: "300+" },
        { label: t("produits_vendus"), value: "50K+" }
      ]
    },
    {
      icon: <UserCog className="w-8 h-8 text-white" />,
      title: t("service_transport"),
      description: t("slogant_transporteur"),
      buttonText: t("devenez_transporteur"),
      buttonLink: "/devenir_transporteur",
      image: "/assets/transt.png",
      gradient: "from-purple-500 to-pink-600",
      stats: [
        { label: t("transporteurs"), value: "200+" },
        { label: t("zones"), value: "50+" }
      ]
    },
    {
      icon: <Package className="w-8 h-8 text-white" />,
      title: t("stock_produit"),
      description: t("slogant_stock"),
      buttonText: t("a_venir"),
      buttonLink: "/comming_stock",
      image: "/assets/Stock_image.jpg",
      gradient: "from-indigo-500 to-purple-600",
      isComingSoon: true,
      stats: [
        { label: t("capacite"), value: "1000+" },
        { label: t("stockage"), value: "m²" }
      ],
      isCommingSoon: true
    },
    {
      icon: <CloudSun className="w-8 h-8 text-white" />,
      title: t("service_meteo"),
      description: t("text_slide5"),
      buttonText: t("a_venir"),
      buttonLink: "/comming_meteo",
      image: "/assets/bg_meteo.png",
      gradient: "from-sky-500 to-blue-600",
      isComingSoon: true,
      badge: t("innovant") || "Innovant",
      stats: [
        { label: t("precisions"), value: "95%" },
        { label: t("previsions"), value: "7j" }
      ],
      isCommingSoon: true
    }
  ];


  return (


    <div className="overflow-hidden transition-all w-full mx-auto max-w-[100vw]">
      {/* Slider Section */}
      <div className=" flex flex-row  bg-white w-full" >
        <Carousel />
      </div>

      {/* nos services */}
      <section className="w-full py-12 bg-gradient-to-br from-gray-50 to-gray-100">
        {/* Header */}
        <div className="max-w-6xl mx-auto px-6 sm:px-12 lg:px-16 mb-12">
          <div className="relative rounded-2xl overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-emerald-700" />
            <div className="absolute inset-0 opacity-10"
              style={{ backgroundImage: "url('/assets/BACKGROUND.png')" }}
            />
            <div className="relative mx-auto px-4 sm:px-6 lg:px-8 py-10 text-center">
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >

                <div className="flex items-center justify-center">
                  <Star className="w-xl h-xl mr-5 mb-5 text-yellow-300 fill-yellow-300" />
                  <h1 className="text-2xl sm:text-4xl font-bold text-white mb-4">
                    {t("nos_services")}
                  </h1>
                </div>

                <p className="text-base sm:text-lg text-white/90 max-w-2xl mx-auto">
                  {t("text_service")}
                </p>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="max-w-6xl mx-auto px-6 sm:px-12 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {services.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>
      </section>

      {/* stat / Communauté agribusiness */}
      <section className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 py-12">
        {usersData && <DashboardStats data={usersData} />}
      </section>

      {/* categorie */}
      <section
        className="w-full py-12 md:py-14` bg-gradient-to-b from-gray-50 to-white"
        aria-labelledby="categories-title"
      >
        <div className="max-w-6xl mx-auto px-6 sm:px-12 lg:px-16">
          {/* En-tête de section */}
          <div className="text-center mb-8 md:mb-12">
            <h2
              id="categories-title"
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-3"
            >
              {t("nos_categorie")}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              {t("categories_description") || "Découvrez notre sélection de catégories"}
            </p>
          </div>

          {/* Grille de catégories */}
          {load ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
              {categories.map((categorie, index) => (
                <motion.button
                  key={categorie.category_id || index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  onClick={() => navigate("/details_categories", { state: categorie })}
                  className="group relative flex flex-col items-center p-4 rounded-2xl transition-all duration-300 hover:bg-white hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                  aria-label={`Voir la catégorie ${categorie.category_name}`}
                >
                  {/* Container d'image avec ratio fixe */}
                  <div className="relative w-full aspect-square mb-4 overflow-hidden rounded-2xl bg-gray-100">
                    <img
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      src={categorie.category_image_url}
                      alt={`Image de la catégorie ${categorie.category_name}`}
                      loading="lazy"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = "/placeholder-category.jpg";
                        target.classList.add("p-8", "opacity-50");
                      }}
                    />

                    {/* Overlay au survol */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                      <span className="text-white font-medium text-sm bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                        {t("explorer") || "Explorer"}
                      </span>
                    </div>


                  </div>

                  {/* Nom de la catégorie */}
                  <h3 className="text-base md:text-lg font-semibold text-gray-900 group-hover:text-green-600 transition-colors duration-300 text-center">
                    {categorie.category_name}
                  </h3>

                  {/* Description optionnelle */}
                  {categorie.description && (
                    <p className="text-xs text-gray-500 mt-1 text-center line-clamp-2">
                      {categorie.description}
                    </p>
                  )}
                </motion.button>
              ))}
            </div>
          )}
        </div>
      </section>




      {/* categorie d'acteur / vendeurs */}
      <section
        className="w-full py-10 md:py-14 bg-gradient-to-b from-gray-50 to-white"
        aria-labelledby="actors-title"
      >
        <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12">
          {/* En-tête de section */}
          <div className="text-center mb-8 md:mb-12">
            <h2
              id="actors-title"
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-3"
            >
              {t("nos_categorie_acteur")}
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              {t("actors_description") || "Découvrez nos producteurs et acteurs locaux"}
            </p>
          </div>

          {/* Grille d'acteurs */}
          {loader ? (
            <Loader />
          ) : userCategories.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">
                {t("aucun_acteur") || "Aucun acteur disponible pour le moment"}
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 place-items-center gap-4 md:gap-6">
              {userCategories.map((userCategorie: any, index: number) => {
                const vendorCategoryImages = [
                  "/assets/Categories/ChatGPT Image 3 sept. 2026, 19_23_42 (1).png",
                  "/assets/Categories/ChatGPT Image 3 sept. 2026, 19_23_43 (2).png",
                  "/assets/Categories/ChatGPT Image 3 sept. 2026, 19_23_43 (3).png",
                  "/assets/Categories/ChatGPT Image 3 sept. 2026, 19_23_44 (4).png",
                  "/assets/Categories/ChatGPT Image 3 sept. 2026, 19_23_44 (5).png",
                  "/assets/Categories/ChatGPT Image 3 sept. 2026, 19_23_45 (6).png",
                ];
                const vendorImage = vendorCategoryImages[index % vendorCategoryImages.length] || userCategorie.image_url;

                return (
                  <motion.button
                    key={userCategorie.acteur_id}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    onClick={() => navigate("/liste_producteur", { state: userCategorie })}
                    className="group relative flex w-full h-full  md:w-[250px] md:h-[300px] flex-col items-center p-4 md:p-6 bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    aria-label={`Voir les produits de ${userCategorie.acteur_name}`}
                  >
                    {/* Badge type d'acteur (optionnel) */}
                    {userCategorie.acteur_type && (
                      <div className="absolute top-3 left-3 z-10">
                        <span className="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                          {userCategorie.acteur_type}
                        </span>
                      </div>
                    )}

                    {/* Container Image */}
                    <div className="relative w-full aspect-square mb-4 md:mb-6 overflow-hidden rounded-2xl bg-gray-100 shadow-inner">
                      <img
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        src={vendorImage}
                        alt={`Photo de ${userCategorie.acteur_name}`}
                        loading="lazy"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = "/placeholder-actor.jpg";
                          target.classList.add("p-8", "opacity-60");
                        }}
                      />

                      {/* Overlay au survol */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center justify-end p-4">
                        <div className="flex items-center gap-2 text-white mb-3">
                          <Eye size={16} />
                          <span className="text-sm font-medium">
                            {t("voir_plus") || "Voir les produits"}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Nom de l'acteur */}
                    <h3 className="text-base md:text-lg font-bold text-gray-900 group-hover:text-green-600 transition-colors duration-300 text-center mb-2">
                      {userCategorie.acteur_name}
                    </h3>

                    {/* Informations supplémentaires */}
                    <div className="w-full space-y-2">
                      {/* Localisation */}
                      {userCategorie.localisation && (
                        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
                          <MapPin size={14} className="text-green-500" />
                          <span>{userCategorie.localisation}</span>
                        </div>
                      )}

                      {/* Note / Évaluation */}
                      {userCategorie.note && (
                        <div className="flex items-center justify-center gap-1">
                          <Star size={14} className="text-yellow-500 fill-current" />
                          <span className="text-sm font-medium text-gray-700">
                            {userCategorie.note}/5
                          </span>
                          {userCategorie.nombre_avis && (
                            <span className="text-xs text-gray-400">
                              ({userCategorie.nombre_avis} {t("avis")})
                            </span>
                          )}
                        </div>
                      )}

                      {/* Nombre de produits */}
                      {userCategorie.product_count > 0 && (
                        <p className="text-xs text-center text-gray-400">
                          {userCategorie.product_count} {t("produits_disponibles")}
                        </p>
                      )}
                    </div>
                  </motion.button>
                );
              })}
            </div>
          )}
        </div>
      </section>


      {/* Popular Products Section */}
      <section className="bg-white py-8 my-4 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 sm:px-12 lg:px-16">
          <div className="flex flex-row items-center justify-center mb-6">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 md:mb-0">
              {t("home_popular_products")}
            </h2>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {popularProduct.slice(0, 6).map((fruit: any) => (
                <div key={fruit.product_id} className="cursor-pointer transform transition-all duration-300 hover:scale-[1.02]" onClick={() => {
                  navigate("/list_products", { state: fruit.product_name })
                }}>
                  <ProductCard
                    key={fruit.product_id}
                    category_name={i18n.language === "fr" ? fruit.category_name : fruit.category_name_en}
                    image={JSON.parse(fruit.images)[0]}
                    sub_category_name={i18n.language === "fr" ? fruit.sub_category_name : fruit.sub_category_name_en}
                    title={i18n.language === "fr" ? fruit.product_name : fruit.product_name_en}
                    stock={null}
                    productId={fruit.product_id}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* New Products Section */}
      <section className="bg-white py-8 my-8 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 sm:px-12 lg:px-16">
          <h2 className="text-2xl md:text-3xl flex flex-row items-center justify-between font-bold mb-6">
            {t("home_new_products")}
            <div onClick={() => navigate("/list_products")} className="text-[#005412] cursor-pointer text-[20px] font-normal items-center flex flex-row">
              {t("voir_plus")}
              <ArrowRight className=" ml-3" />
            </div>
          </h2>

          {loading ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {newProduct.map((fruit: any) => (
                <div key={fruit.product_id} onClick={() => navigate(`/detail_produit/${fruit.product_id}`)} className="cursor-pointer transform transition-all duration-300 hover:scale-[1.02]" >
                  <ProductCard
                    key={fruit.product_id}
                    category_name={fruit.category_name}
                    image={JSON.parse(fruit.images)[0]}
                    sub_category_name={fruit.sub_category_name}
                    title={i18n.language === "fr" ? fruit.product_name : fruit.product_name_en}
                    quality={fruit.minimum_quantity}
                    price={fruit.price}
                    quantity={fruit.totalQuantity}
                    uml={fruit.type}
                    stock={fruit.stock_quantity}
                    productId={fruit.product_id}
                    seller={fruit.producer_name}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <ToastContainer position="top-right" />
    </div>



  );
};

export default Home;